export default __webpack_public_path__ + "static/media/appIcon.88558f5a.png";